import styled from 'styled-components';
export const SelectPayerContainer = styled.div `
  width: 100%;
`;
